import { render } from "./tw-tag.vue?vue&type=template&id=24ec1df5"
import script from "./tw-tag.vue?vue&type=script&lang=js"
export * from "./tw-tag.vue?vue&type=script&lang=js"
script.render = render

export default script